import { create } from "zustand"

type VoicePerson = {
  id: string
  name: string
  title?: string
  phone?: string
  account?: { id: string; name: string }
}

type VoiceSessionStore = {
  bulkPeople: VoicePerson[] | null
  single: VoicePerson | null
  startBulk: (people: VoicePerson[]) => void
  startSingle: (person: VoicePerson) => void
  closeBulk: () => void
  closeSingle: () => void
}

const useVoiceSessionStore = create<VoiceSessionStore>((set) => ({
  bulkPeople: null,
  single: null,
  startBulk: (people) => set({ bulkPeople: people }),
  startSingle: (person) => set({ single: person }),
  closeBulk: () => set({ bulkPeople: null }),
  closeSingle: () => set({ single: null })
}))

export default useVoiceSessionStore
